import {
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';

import type { ActurisContact } from 'api/quote-marketplace';

interface ContactResultsTableProps {
  headers: string[];
  contacts: ActurisContact[];
  onRowClick: (contact: ActurisContact) => void;
}

const ContactResultsTable = ({
  headers,
  contacts,
  onRowClick,
}: ContactResultsTableProps) => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const hoverBgColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Table variant="simple" color="gray.500" mt="10px">
      <Thead>
        <Tr>
          {headers.map((header) => (
            <Th
              key={header}
              pe="10px"
              borderColor={borderColor}
              color="gray.400"
              borderTop="1px solid"
              borderTopColor={borderColor}
            >
              {header}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {contacts.map((contact) => (
          <Tr
            key={contact.contact_ref}
            cursor="pointer"
            _hover={{ bg: hoverBgColor }}
            onClick={() => onRowClick(contact)}
          >
            <Td>
              <Text color={textColor} fontSize="sm" fontWeight="700">
                {contact.name}
              </Text>
              <Text color="gray.500" fontSize="xs">
                {contact.contact_ref}
              </Text>
            </Td>
            <Td>
              <Text color={textColor} fontSize="sm" fontWeight="700">
                {contact.address || '-'}
              </Text>
            </Td>
            <Td>
              <Text color={textColor} fontSize="sm" fontWeight="700">
                {contact.postcode || '-'}
              </Text>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default ContactResultsTable;
